import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  @media ${({ theme }) => theme.device.mobile} {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
`;

export const Section = styled.section`
  display: flex;
  align-items: center;
  @media ${({ theme }) => theme.device.mobile} {
    margin: 4px;
  }
`;
interface PageProps {
  $disabled?: boolean;
}

export const Page: any = styled.span<PageProps>`

  align-items: center;
  & .icons {
    vertical-align: middle;
    color: ${({ $disabled, theme }) => ($disabled ? ColorPalette.HEX.Manatee : theme.primaryBackgroundColor)} !important;
  }
  @media ${({ theme }) => theme.device.mobile} {
    font-size: 16px;
  }
`;

Page.Summary = styled.span`
  padding: 1px 6px;
  color: ${ColorPalette.HEX.DimGray};
  @media ${({ theme }) => theme.device.mobile} {
    padding: 4px 8px;
    font-size: 16px;
  }
`;
Page.Current = styled.span`
  padding: 1px 6px;
  background: ${({ theme }) => theme.primaryBackgroundColor};
  box-shadow: 0 2px 12px 0 rgb(128 98 96 / 16%);
  color: ${ColorPalette.HEX.White};
  border-radius: 4px;
  font-weight: 600;
  margin: 0 3px;
  @media ${({ theme }) => theme.device.mobile} {
    padding: 4px 8px;
    font-size: 16px;
  }
`;
Page.Link = styled.a<PageProps>`
  padding: 1px 6px;
  margin: 0 2px;
  cursor: pointer;
  color: ${({ $disabled, theme }) => ($disabled ? ColorPalette.HEX.Manatee : theme.primaryBackgroundColor)} !important;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 4px 8px;
    font-size: 16px;
  }
`;

export const IconPrev = styled(IoIosArrowBack)``;
export const IconNext = styled(IoIosArrowForward)``;
